// extracted by mini-css-extract-plugin
export default {"AdminPanelModule":"EditHumanModule_AdminPanelModule__DaBiP","ArrowBack":"EditHumanModule_ArrowBack__INffY","search__inner":"EditHumanModule_search__inner__gfv-s"};